import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// import AddTestDirect from "./AddTestDirect";
// import SampleCollection from "./SampleCollection";
// import PatientReplace from "./AddResult";
import BillUpdate from "./BillUpdate";
// import FeeHeadSub from "./FeeHeadSub";
// import FeeHeads_Import from "./FeeHeads_Import";
import { Container } from "@mui/system";
import PaymentMode from "../Admin/PaymentMode";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 3 }}>
          {/* <Typography> </Typography> */}
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function SystemParameter() {
  // export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs" variant="scrollable"  scrollButtons allowScrollButtonsMobile>
          {/* <Tab label="Add-Test-Direct" {...a11yProps(1)} /> */}
          {/* <Tab label="Sample Collection" {...a11yProps(1)} /> */}
          <Tab label="Payment-Mode" {...a11yProps(0)} />
          <Tab label="Bill-Update" {...a11yProps(1)} />
          {/* <Tab label="AAAAA" {...a11yProps(2)} /> */}
        </Tabs>
      </Box>    
      <TabPanel value={value} index={0}>
        <PaymentMode />
      </TabPanel>   
      <TabPanel value={value} index={1}>
        <BillUpdate />
      </TabPanel>
     
    </Box>
  );
}

